/* N4 (2026-10-22) — THE MARKETING SITE'S BUILD-TIME PIECES, as pure functions a test can execute.
 *
 * `home.html` and `coaches.html` are static entries like the legal pages: no JavaScript of their own (Home
 * carries only `/site-forward.js`). What they share with the app is filled in AT BUILD by vite.config.ts's
 * `site()` plugin from the ONE source each already has — the plate from `mark.ts` (generated from
 * `design/AppIcon/generate.py`), the beta link from `appLink.ts` — so neither is typed a second time.
 */
import { MARK_C_PATH, MARK_C_STROKE, MARK_ICON_LAYERS, MARK_ICON_VIEWBOX } from "./mark";

/** Where the coach web app lives since the site took the root (netlify.toml rewrites `/app` to index.html). */
export const APP_PATH = "/app";

/** The query that opens the app's sign-in screen on "Create your coach account" — the For-coaches page's door. */
export const SIGN_UP_QUERY = "signup";

/** True when the app was opened from a "create an account" link (`/app?signup`). */
export function opensOnSignUp(search: string): boolean {
  return new URLSearchParams(search.startsWith("?") ? search.slice(1) : search).has(SIGN_UP_QUERY);
}

/** The plate as static SVG markup — the same layers `BrandLockup.tsx` draws, with the same tokens. */
export function markSvg(className = "brand-mark"): string {
  const layers = MARK_ICON_LAYERS.map((l) =>
    `<path d="${l.d}" fill="var(${l.token})"${l.evenOdd ? ' fill-rule="evenodd"' : ""}${l.opacity === undefined ? "" : ` opacity="${l.opacity}"`}/>`,
  ).join("");
  const c = `<path d="${MARK_C_PATH}" fill="none" stroke="var(--ht-plate-creme)" stroke-width="${MARK_C_STROKE}" stroke-linecap="round"/>`;
  return `<svg class="${className}" viewBox="${MARK_ICON_VIEWBOX}" aria-hidden="true" focusable="false">${layers}${c}</svg>`;
}

/** The lockup (plate + "oachwork"), named once for assistive tech — the BrandLockup shape. */
export function lockupHtml(): string {
  return `<span class="brand-lockup" aria-label="coachwork">${markSvg()}<span class="brand-word" aria-hidden="true">oachwork</span></span>`;
}

/** Replace every `<!--ht-…-->` marker; one this function does not know (a typo) fails the build rather than shipping
 *  as an invisible comment where the logo or the link should be. */
export function fillMarkers(html: string, file: string, fills: Record<string, string>): string {
  let out = html;
  for (const [marker, value] of Object.entries(fills)) out = out.split(marker).join(value);
  const left = out.match(/<!--ht-[a-z-]+-->/g);
  if (left !== null) throw new Error(`${file}: unknown marker(s) ${left.join(", ")}`);
  return out;
}
